import React from "react";

export default function drafticon() {
    return (
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.4 12V2.22222C9.4 1.89807 9.27357 1.58719 9.04853 1.35798C8.82348 1.12877 8.51826 1 8.2 1H5.8C5.48174 1 5.17652 1.12877 4.95147 1.35798C4.72643 1.58719 4.6 1.89807 4.6 2.22222V12M2.2 3.44444H11.8C12.4627 3.44444 13 3.99165 13 4.66667V10.7778C13 11.4528 12.4627 12 11.8 12H2.2C1.53726 12 1 11.4528 1 10.7778V4.66667C1 3.99165 1.53726 3.44444 2.2 3.44444Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
